module.exports = __webpack_public_path__ + "img/newS.f0a115ac.svg";